/**
 * Game configuration constants for Zenith
 * "Tactile Minimalism" aesthetic with Morning Fog color palette
 */

// Color palette - Morning Fog ("Tactile Minimalism" aesthetic)
export const COLORS = {
  // Base colors
  BACKGROUND: 0xe0e5ec, // Pale Blue-Grey
  BACKGROUND_TOP: 0xe8ecf2, // Lighter gradient top
  BACKGROUND_BOTTOM: 0xd8dde4, // Darker gradient bottom
  PLATFORM: 0x2d3436, // Charcoal

  // Shape colors
  SQUARE: 0xf8b4b4, // Pastel Coral
  CIRCLE: 0xb8d4c8, // Sage Green
  TRIANGLE: 0xa8b5c4, // Slate Blue

  // UI colors
  UI_TEXT: 0x2d3436, // Charcoal
  UI_ACCENT: 0x636e72, // Medium Grey
  UI_ACCENT_MUTED: 0x7c9885, // Muted Green
  WARNING: 0xd4a8a8, // Soft Red
  SUCCESS: 0x4caf50, // Green
  ZENITH_LINE: 0x9ba4b0, // Grey-Blue

  // Visual effects
  SHADOW: 0x000000,
  HIGHLIGHT: 0xffffff,
} as const;

// Game dimensions - mobile-first
export const GAME = {
  WIDTH: 390,              // iPhone 14 logical width
  HEIGHT: 844,             // iPhone 14 logical height
  GRAVITY: 1,              // Matter.js gravity scale
  DEBUG_PHYSICS: false,    // Toggle physics debug rendering
} as const;

// Physics constants for Matter.js
export const PHYSICS = {
  GRAVITY_Y: 1,
  FRICTION_DEFAULT: 0.5,
  FRICTION_STATIC: 0.8,
  RESTITUTION: 0.1,        // Low bounce for stability
  SLOP: 0.01,              // Collision tolerance
} as const;

// Shape properties
export const SHAPES = {
  SQUARE: {
    SIZE: 60,
    MASS: 1.0,
    FRICTION: 0.8,
  },
  CIRCLE: {
    RADIUS: 30,
    MASS: 0.8,
    FRICTION: 0.4,
  },
  TRIANGLE: {
    SIZE: 60,
    MASS: 0.5,
    FRICTION: 0.8,
  },
} as const;

// Gameplay constants
export const GAMEPLAY = {
  ZENITH_LINE_Y: 200,      // Win height from top
  STABILITY_TIME: 3000,    // ms to hold for win
  SPAWN_Y: 50,             // Y position for new pieces
  PLATFORM_Y: 750,         // Platform Y position
  PLATFORM_WIDTH: 300,
  PLATFORM_HEIGHT: 20,
} as const;

// Slide mechanic tuning
export const SLIDE = {
  SENSITIVITY: 0.8,          // How much piece moves per pixel drag
  DEADZONE: 3,               // Minimum drag distance to register (px)
  MAX_DISTANCE: 100,         // Maximum slide distance from landing point (px)
  COM_WARNING_THRESHOLD: 50, // Distance from center before CoM warning (px)
} as const;

// Scene keys
export const SCENES = {
  BOOT: 'BootScene',
  PRELOAD: 'PreloadScene',
  MENU: 'MenuScene',
  GAME: 'GameScene',
  GAME_OVER: 'GameOverScene',
} as const;
